export default "__VITE_ASSET__CmvfNuDt__"